import angular from 'angular';

import '../../../module/settlement/onlineCardReconciliationByStoreSummary/controller'
document.write(require('./view.html').default);

angular.module("merchant.application.page.settlement.onlineCardReconciliationSummary", [
    "merchant.application.module.settlement.onlineCardReconciliationByStoreSummary"
]).controller("merchant.application.page.settlement.onlineCardReconciliationSummary.controller", [
    "$rootScope", "$scope", "$controller", "$routeParams",
    function($rootScope, $scope, $controller, $routeParams) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        if ($routeParams.uuid) {
            $scope.model.uuid = $routeParams.uuid;
        }

    }
]);
